import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import './CyberMondayBanner.css';
import { trackButtonClick } from '@/utils/analytics';

const CyberMondayBanner = ({
  campaignStartDate,
  campaignChangeDate,
  campaignEndDate,
  startMessage,
  endMessage,
  redirectUrl,
  onVisibilityChange
}) => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [message, setMessage] = useState(startMessage);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const CAMPAIGN_START = new Date(campaignStartDate);
    const CAMPAIGN_CHANGE = new Date(campaignChangeDate);
    const CAMPAIGN_END = new Date(campaignEndDate);

    const calculateDiff = (start, end) => {
      const diff = end - start;
      if (diff <= 0) return null;

      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000)
      };
    };

    const updateTimer = () => {
      const now = new Date();
      let time = null;

      if (now < CAMPAIGN_START) {
        setMessage(startMessage);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsVisible(true);
        onVisibilityChange?.(true);
        return;
      } else if (now >= CAMPAIGN_START && now < CAMPAIGN_CHANGE) {
        setMessage(startMessage);
        time = calculateDiff(now, CAMPAIGN_CHANGE);
      } else if (now >= CAMPAIGN_CHANGE && now < CAMPAIGN_END) {
        setMessage(endMessage);
        time = calculateDiff(now, CAMPAIGN_END);
      }

      if (time) {
        setTimeLeft(time);
        setIsVisible(true);
        onVisibilityChange?.(true);
      } else {
        setIsVisible(false);
        onVisibilityChange?.(false);
      }
    };

    updateTimer();
    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);
  }, [campaignStartDate, campaignChangeDate, campaignEndDate, startMessage, endMessage]);

  const handleClick = () => {
    trackButtonClick({
      eventName: "cyber_monday_banner_click",
      eventCategory: "Banner",
      eventSource: "Cyber Monday Banner",
      eventLabel: redirectUrl,
    });
    window.open(redirectUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="cyber-monday-banner" onClick={handleClick}>
      <div className="banner-content">
        <div className="banner-message-cyberm">{message}</div>
        <div className="timer-display-cyber">
          {timeLeft.days > 0 ? (
            `${timeLeft.days} d : ${String(timeLeft.hours).padStart(2, '0')} h : ${String(timeLeft.minutes).padStart(2, '0')} m`
          ) : (
            `${String(timeLeft.hours).padStart(2, '0')} h : ${String(timeLeft.minutes).padStart(2, '0')} m : ${String(timeLeft.seconds).padStart(2, '0')} s`
          )}
        </div>
      </div>
    </div>
  );
};

export default CyberMondayBanner;
